import { RouteName } from "../RouteNames";

export const questionsRoutes = {
  path: "questions",
  children: [
    {
      name: RouteName.Questions,
      path: "",
      component: () =>
        import("@follaw-fr/views/side_menu_views/QuestionsView.vue"),
    },
    {
      name: RouteName.QuestionsFollawed,
      path: "follawed",
      component: () =>
        import("@follaw-fr/views/side_menu_views/QuestionsView.vue"),
    },
    {
      name: RouteName.QuestionsZoom,
      path: ":_id",
      component: () =>
        import("@follaw-fr/views/side_menu_views/QuestionsZoomView.vue"),
    },
  ],
};
